<template>
	<div class="card-option-item-button">
		<button @click="actionGoTo" class="card-option-item-button__button">
			<span>{{ title }}</span>
		</button>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
	name: 'card-option-item-button',
	props: {
		title: {
			type: String,
			default: null
		}
	},
	methods: {
		actionGoTo() {
			this.$parent.$emit('close')
			this.$emit('click')
		}
	}
}
</script>

<style scoped>
a > span,
button > span {
	transform: translate(0, 0);
	transition: all 300ms;
	display: inline-block;
}
a:hover > span,
button:hover > span {
	transform: translate(5px, 0);
	font-weight: 700;
}
.card-option-item-button {
	padding: 0;
	position: relative;
	width: 100%;
}
.card-option-item-button__button {
	border: 0;
	border-bottom: 1px solid rgba(255, 255, 255, 0.25);
	background: transparent;
	color: #fff;
	font-size: 14px;
	font-weight: 300;
	box-sizing: border-box;
	cursor: pointer;
	text-decoration: none;
	outline: none;
	position: relative;
	transition: color 0.3s;
	width: 100%;
	display: flex;
	justify-content: center;
	padding: 10px;
}
.card-option-item-button__button > span {
	padding: 7px 0;
	display: block;
	white-space: nowrap;
}
.card-option-item-button:last-child .card-option-item-button__button {
	border-bottom: 1px solid transparent;
}
</style>



// WEBPACK FOOTER //
// src/modules/common/CardOptionItemButton.vue